import type React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './PrivacyPolicy.css';

interface PrivacySection {
  title?: string;
  subtitle?: string;
  content?: string;
  list?: string[];
  footer?: string;
}

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  const sections = t('privacy.sections', { returnObjects: true }) as PrivacySection[];

  return (
    <div className="privacy-page">
      <div className="bg-accent-shape" />
      <Header />

      <main className="privacy-main">
        <section className="privacy-hero">
          <div className="privacy-hero-content">
            <div className="hero-line" />
            <h2 className="hero-label">{t('privacy.heroLabel', 'Legal')}</h2>
            <div className="hero-line" />
          </div>
          <h1 className="hero-title">{t('privacy.title', 'Privacy Policy')}</h1>
          <p className="privacy-last-updated">
            {t('privacy.lastUpdated', 'Last Updated: 01.01.2026')}
          </p>
        </section>

        <section className="privacy-content">
          <div className="privacy-intro">
            {t('privacy.intro', 'TheyChat is...')
              .split('\n')
              .map((paragraph) => (
                <p key={`intro-${paragraph.slice(0, 20)}`}>{paragraph}</p>
              ))}
          </div>

          {Array.isArray(sections) &&
            sections.map((section, index) => (
              <div
                className={`privacy-section ${!section.title ? 'subsection' : ''}`}
                key={`section-${index}-${section.title || section.content?.slice(0, 20)}`}
              >
                {section.title && <h2>{section.title}</h2>}
                {section.subtitle && <h3>{section.subtitle}</h3>}

                {section.content && (
                  <div className="privacy-section-content">
                    {section.content.split('\n').map((paragraph, pIndex) => (
                      <p key={`content-${index}-${pIndex}-${paragraph.slice(0, 10)}`}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
                {section.list && (
                  <ul className="privacy-list">
                    {section.list.map((item, itemIndex) => (
                      <li key={`item-${index}-${itemIndex}-${item.slice(0, 10)}`}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.footer && (
                  <div className="privacy-section-footer">
                    {section.footer.split('\n').map((paragraph, pIndex) => (
                      <p key={`footer-${index}-${pIndex}-${paragraph.slice(0, 10)}`}>{paragraph}</p>
                    ))}
                  </div>
                )}
              </div>
            ))}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
